import React, { useMemo } from 'react';
import { selectErroriEvento, selectHasSospesi, selectIsScommettibile, selectTicket } from 'features/sport/components/sportTicket/sportTicketSelectors';

import { formatValueByDivisor } from 'features/carrello/utils';
import { isSnaiSite } from 'utility/constant';
import { selectSaldo } from 'features/dashboard/selectors';
import { useInternalSession } from 'hooks/useInternalSession';
import { useTypedSelector } from 'lib/centralStore';

export const useFormattedValue = (value: number) => {
  return useMemo(() => formatValueByDivisor(value, 100), [value]);
};

export const useCanBet = (isLoadingMultipla: boolean, isLoadingSistema: boolean) => {
  const ticket = useTypedSelector(selectTicket);
  const isScommettibile = useTypedSelector(selectIsScommettibile);
  const erroriEvento = useTypedSelector(selectErroriEvento);
  const hasSospesi = useTypedSelector(selectHasSospesi);
  const { session, isAuthenticated } = useInternalSession();

  const saldo = useTypedSelector(selectSaldo);

  return useMemo(() => {
    return isSnaiSite
      ? ([
          isAuthenticated,
          isScommettibile,
          ticket?.errori?.length === 0,
          ticket?.erroreInserimento === undefined,
          saldo > 0 || +session?.user?.saldo! > 0,
          erroriEvento.length === 0,
          !hasSospesi,
        ].every(Boolean) &&
          !isLoadingMultipla) ||
          !isLoadingSistema
      : ([
          isAuthenticated,
          isScommettibile,
          ticket?.errori?.length === 0,
          ticket?.erroreInserimento === undefined,
          saldo > 0 || +session?.user?.saldo! > 0,
          erroriEvento.length === 0,
          !hasSospesi,
        ].every(Boolean) &&
          !isLoadingMultipla) ||
          !isLoadingSistema;
  }, [
    isAuthenticated,
    isScommettibile,
    isLoadingMultipla,
    isLoadingSistema,
    ticket?.erroreInserimento,
    ticket?.errori,
    session?.user?.saldo,
    erroriEvento,
    hasSospesi,
    saldo,
  ]);
};